module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.stepPreview.kind === 'welcome') ? _c('welcome') : _vm._e(), _vm._v(" "), (_vm.stepPreview.kind === 'multiple-choice' || _vm.stepPreview.kind === 'yes-no') ? _c('question') : _vm._e(), _vm._v(" "), (_vm.stepPreview.kind === 'email') ? _c('form-email') : _vm._e(), _vm._v(" "), (_vm.stepPreview.kind === 'text') ? _c('text-field') : _vm._e(), _vm._v(" "), (_vm.stepPreview.kind === 'redirect') ? _c('redirect') : _vm._e(), _vm._v(" "), (_vm.stepPreview.kind === 'thanks') ? _c('thanks') : _vm._e()], 1)
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-09877768!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/preview/step/Main.vue
 ** module id = 755
 ** module chunks = 1
 **/